import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Lang } from '../../core/types';
import ReactMarkdown from 'react-markdown';
import Header from '../../components/Header/Header';
import { HEADER_BLOCK_KEY } from '../../core/constants';
import rehypeRaw from 'rehype-raw';
import './TermsOfService.scss';
import { PublicRoutesEnum } from '../../core/enums';
import Footer from '../../components/Footer/Footer';

export const TERMS_OF_SERVICE_VERSION = 'v20220614';

const getTerms = async (lang: Lang) => {
  let res = undefined;
  if (lang === 'de') {
    res = await axios.get(
      `${PublicRoutesEnum.TermsOfService}/${TERMS_OF_SERVICE_VERSION}-de.md`
    );
  } else {
    res = await axios.get(
      `${PublicRoutesEnum.TermsOfService}/${TERMS_OF_SERVICE_VERSION}.md`
    );
  }
  return res.data;
};

export default function TermsOfService() {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const [content, setContent] = useState('');

  useEffect(() => {
    setContent('');
    getTerms(language as Lang).then((res) => setContent(res));
  }, [language]);

  if (!content) return null;

  return (
    <div className='min-vh-100 TermsOfService d-flex flex-column'>
      <Header blockKey={HEADER_BLOCK_KEY} />
      <ReactMarkdown
        children={content}
        className='TermsOfService__container flex-grow-1'
        rehypePlugins={[rehypeRaw]}
      />
      <Footer />
    </div>
  );
}
